// declaracion de metodos y variables en status 

export default {
    display: false,
    displayEdit:[],    
    //auth : true,
    account : false,
    token: localStorage.getItem('access_token_m') || null,
    orgAll : [],
    appAll : [],
    infoorg : null,
    privilegies: [],
    modulos: [],
    token_b: localStorage.getItem('access_token') || null,
    dimenu: false,
    showAside: false,
    appIDactual: 0,
    menutab: {},
    menuCatActive: {
        cat:{
            platos: []
        }
    },
    retornoAside: {},
    dataAsideMenu : {
        swich: false,
        existSizes: false,
        existFoods: false,
    },
    imageActiveFood : null,
    // specials
    SpecialsItemActive : {display:false},
    actionUpdate : false,
    SpecialsLists : [],
    groupActive : 0,
    groupList : [],
    listCategores : [],
    reserve:[],
    urlWebDimenu: '',
    accitonPusher: [],
    /* newFoodAction : true, */
    cropperImagenes:[],
    getOpenModal:{
		show: false,
		component: '',
		data: [],
	},
    getCloseModal:'',
	loadingModal: false,  
    variantData:[],
    variantFoodData:[], 
    newFoodCat:[],
};
